import AutoQueryTagFilter from "servicestack/auto-query/auto-query-tag-filter.model";
import $pageConfig from "webutils/services/page-config";

export default class AutoQueryNav extends AutoQueryTagFilter {
  constructor(config, $aq) {
    super(config, $aq);
    const g = this;
    g.processing = g.processed = false;
  }

  process(initialize) {
    const g = this;
    let tagCriteria = {};
    !initialize && g.query.clearRefinements(false);
    g.query.navs
      .filter((nav) => g.index > nav.index)
      .forEach((nav) => (tagCriteria[nav.tagKind] = nav.getParams()));
    g.processing = new Date();
    g.processed = false;
    !initialize && g.clear();
    console.debug("process$aqNav", g.$$url, { initialize, g });
    return g.bus
      .read(g.$$url, { ...g.baseCriteria, tagCriteria })
      .then((res) => {
        g.processed = new Date();
        g.processing = false;
        if (initialize && g.next && g.getParams().length) {
          g.next.process(initialize);
        }
        return (g.items = res.data.results);
      });
  }

  readQueryStringShouldHydrate(values) {
    const g = this;
    // console.warn("readQueryStringShouldHydrate", g.lowerTagKind, {
    //   values,
    // });
    return values.length;
  }

  clear(leaveItems) {
    const g = this;
    super.clear();
    if (!leaveItems) g.items = [];
    g.next && g.next.clear();
  }

  select(tag, doNotLoad) {
    const g = this;
    g.clear(true);
    g.toggle(tag); // TODO: revisit
    g.next &&
      g.next.process().then((tags) => {
        if (g.isSelected(tag) && g.next.autoSelectFirst && tags.length > 1) {
          g.next.select(tags[0]);
        }
      });
    g.query.clearRefinements(false);
  }

  backToHere() {
    const g = this;
    g.next && g.next.clear();
    g.query.clearRefinements(true);
    $pageConfig.goTop();
  }
}
